"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ca: ()=>ca
});
const index_js_namespaceObject = require("@cian/core/errors/index.js");
function yieldToMainThread() {
    if (globalThis.scheduler?.yield) return globalThis.scheduler.yield();
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const ERR_DOMAIN = 'analytics.lib';
const caAsync = async (command, ...args)=>{
    await yieldToMainThread();
    window.ca(command, ...args, {
        version: "1.3.2-CD-248981.0"
    });
};
function ca(command, ...args) {
    if ('undefined' == typeof window) throw new index_js_namespaceObject.ConfigurationError({
        message: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0426\u0438\u0430\u043D \u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0443 \u0432\u043D\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430",
        domain: ERR_DOMAIN
    });
    caAsync(command, ...args);
}
exports.ca = __webpack_exports__.ca;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ca"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
